
import './App.css';
import Scroll_To_top from './componants/Scroll_To_top';
import { Route, Routes} from "react-router-dom";
import Navbar from './componants/navbar/Navbar';
import Home_main from './componants/home/Home_main';
import Store from './componants/Store/Store';
import Apout from './componants/Apout/Apout';
import CartContext from './componants/context/CartContext';
import Fotter from './componants/fotter/Fotter';
import Registration from './componants/services/Registration';
import CartPage from './componants/Store/CartPage';
import ContactUs from './componants/services/ContactUs';
import Privacy_Policy from './componants/services/Privacy_Policy';
import Product_details from './componants/Store/Product_details';
import {WishList} from './componants/Store/WishList';
import SERVICES from './componants/services/SERVICES';
import Login from './componants/services/Login';
import Checkout from './componants/Store/Checkout';
import DarkMode from './DarkMode/DarkMode'
function App() {
  return (
    <div className="App">
  
<CartContext>  
        <Navbar />
           
     <Routes>
        <Route path='/' element={<Home_main/>}/>      
        <Route path='/Apout' element={<Apout/>}/> 
        <Route path='/Store' element={<Store />} />  
        <Route path='/Services' element={<SERVICES/>} />            

        <Route path='/Registration' element={<Registration/>} />  
        <Route path='/WishList' element={<WishList/>} /> 
        <Route path='/CartPage' element={<CartPage />} /> 
        <Route path='/Checkout' element={<Checkout/>} />   
        <Route path='/Product_details/:id' element={<Product_details/>} />  
        <Route path='/Privacy_Policy' element={<Privacy_Policy/>} />
          
        <Route path='/ContactUs' element={<ContactUs/>} />
        <Route path='/Login' element={<Login/>} />
      </Routes>
        <Fotter />
    <Scroll_To_top/>
</CartContext>        
    </div>
  );
}

export default App;
